import { EyeIcon, Flex, HelpHover, Panel, Text } from 'components'

interface Props {
  children?: React.ReactNode
  aboveHeader?: boolean
  previewMode?: boolean
}

export default function FormSection({ children, aboveHeader, previewMode }: Props) {
  return (
    <Flex direction="column" w="100%" mt={-12} p={4} zIndex={aboveHeader || previewMode ? 2 : 0}>
      {previewMode && (
        <Flex
          borderTopRadius="md"
          bg="rgba(232, 58, 90, 1)"
          p={2}
          px={4}
          justify="space-between"
          color="white"
        >
          <Flex gap={2} align="center">
            <EyeIcon size="md" />
            <Text textStyle="bodySmall">Preview Mode</Text>
          </Flex>
          <HelpHover text="Event is currently not active, the information you enter will not be recorded." />
        </Flex>
      )}
      <Panel
        borderTopRadius={previewMode ? 0 : 'md'}
        gap={3}
        p={4}
        pt={aboveHeader || previewMode ? 2 : 10}
      >
        {children}
      </Panel>
    </Flex>
  )
}
